<template>
  <svg width="150" height="50" viewBox="0 0 150 50" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" :aria-label="orgName">
    <!-- Brand icon (shared across all locales) -->
    <ellipse cx="24.9475" cy="24.9485" rx="24.9475" ry="24.9485" fill="#08afea" />
    <ellipse cx="24.9475" cy="24.9485" rx="24.9475" ry="24.9485" fill="url(#logo-gradient)" />
    <path
      d="M 39.1595,14.7722 C 30.9636,9.81893 25.1214,15.6592 25.1214,15.6592 18.3377,9.81015 11.0497,14.7107 11.0497,14.7107 L 5.80434,26.4878 C 15.9504,25.0914 20.8175,30.9668 20.952,31.1336 13.7144,25.8379 5.24113,28.2706 4.98054,28.3408 l -1.08438,2.4415 h 0.01682 c 2.76558,-0.7113 5.17812,-1.0011 7.27122,-1.0011 7.8176,0 11.1128,3.9344 11.1128,3.9344 C 14.1768,28.4901 2.9715,32.8637 2.9715,32.8637 l -1.31134,2.9509 c 16.07234,-6.1388 21.87254,0.0176 21.87254,0.0176 1.6392,-0.6324 3.1102,0.0263 3.1102,0.0263 7.1199,-6.2793 21.5783,-0.0878 21.8894,0.0439 z M 24.1127,33.6102 C 18.6908,23.6335 8.90617,24.1956 8.90617,24.1956 l 3.24473,-8.4662 c 7.8849,-4.277 12.4998,0.6587 12.4998,0.6587 z m 2.1015,0.5445 V 34.0933 L 25.5081,16.4145 c 2.8749,-2.9421 7.2544,-2.3713 7.2544,-2.3713 l 2.0763,11.9703 0.042,-0.0263 1.2021,-0.9046 1.4963,0.5182 -2.8244,-11.2326 c 1.9165,0.4479 3.3203,1.4315 3.3203,1.4315 l 6.1785,16.2736 -0.1429,-0.0702 C 31.9303,28.3672 26.2142,34.1547 26.2142,34.1547 Z"
      fill="#ffffff"
    />
    <defs>
      <linearGradient id="logo-gradient" x1="4.7175999" y1="24.9485" x2="54.348301" y2="24.9485" gradientUnits="userSpaceOnUse">
        <stop stop-color="#09AFEA" />
        <stop offset="0.9999" stop-color="#19E089" />
        <stop offset="1" stop-color="#19E089" />
      </linearGradient>
    </defs>
    <!-- Two text lines from config (brand text, per site, NOT i18n-switched) -->
    <text x="56.9" y="19.66" :font-family="fontFamily" font-weight="700" :fill="textFill" style="font-size:15px">{{ line1 }}</text>
    <text x="56.47" y="41.27" :font-family="fontFamily" font-weight="700" :fill="textFill" style="font-size:19px">{{ line2 }}</text>
  </svg>
</template>

<script setup lang="ts">
// Dynamic brand wordmark: shared icon + two text lines pulled from
// app.config.site.logoLines (per site). No per-locale SVG files to maintain.
// Text is brand-fixed (does NOT change with the i18n language switcher).
// tone: 'dark' for light backgrounds (header), 'light' for dark ones (footer).
const props = withDefaults(defineProps<{ tone?: 'dark' | 'light' }>(), { tone: 'dark' })

const config = useAppConfig()
const orgName = computed(() => config.site?.orgName ?? 'Школа Біблії')
const lines = computed(() => (config.site?.logoLines as { line1: string; line2: string } | undefined) ?? { line1: 'ШКОЛА', line2: 'БІБЛІЇ' })
const line1 = computed(() => lines.value.line1)
const line2 = computed(() => lines.value.line2)
const textFill = computed(() => (props.tone === 'light' ? '#ffffff' : '#252840'))

// Noto Sans Armenian covers Armenian script (Montserrat has no Armenian glyphs).
// Browser picks the first font that has the required glyph, so both scripts work.
const fontFamily = "'Noto Sans Armenian', Montserrat, 'Helvetica Neue', Arial, sans-serif"
</script>
